import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Info } from 'lucide-react';
import { DataTable } from './UIComponents';
import { formatNumber, formatDate } from './formatters';

const StockCompany = ({ data }) => {
  const { t } = useTranslation();
  const companyData = [
    { label: t('stocks.fields.fullName'), value: data.companyName },
    { label: t('stocks.fields.industry'), value: data.sicDescription || '--' },
    { label: t('stocks.fields.sector'), value: data.sicDescription ? data.sicDescription.split(' ')[0] : '--' },
    { label: t('stocks.fields.exchange'), value: data.primaryExchange || '--' },
    { label: t('stocks.fields.employees'), value: formatNumber(data.totalEmployees) },
    { label: t('stocks.fields.foundedIpo'), value: formatDate(data.listDate) },
    { label: t('stocks.fields.headquarters'), value: data.address ? `${data.address.city ?? ''}${data.address.state ? ', ' + data.address.state : ''}` : '--' },
    { label: t('stocks.fields.sicCode'), value: data.sicCode || '--' },
    { label: t('stocks.fields.website'), value: data.homepage ? t('stocks.company.websiteAvailable') : '--' },
  ];

  return (
    <div className="space-y-8">
      {/* Company description */}
      {data.description && (
        <div className="bg-gradient-to-r from-gray-50 to-white border border-gray-200 hover:border-gray-300 dark:from-gray-800/60 dark:to-gray-800/40 dark:border-gray-700/60 dark:hover:border-gray-600/80 rounded-xl p-6 transition-all duration-300">
          <h4 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-4 flex items-center gap-2">
            <div className="p-1.5 rounded-lg bg-blue-100 dark:bg-blue-500/10 border border-blue-500/20">
              <Info className="w-4 h-4 text-blue-700 dark:text-blue-400" />
            </div>
            {t('stocks.company.descriptionHeading')}
          </h4>
          <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">{data.description}</p>
        </div>
      )}

      <DataTable
        title={t('stocks.tableTitles.companyInformation')}
        icon={Building2}
        data={companyData}
        defaultExpanded={true}
      />
    </div>
  );
};

export default StockCompany;